<template>
  <b-row>
    <b-col cols="12" class="mt-3 mb-3">
      <b-overlay :show="busy" rounded="sm">
        <b-card header-class="custom-header-bg" body-class="p-5">
          <template v-slot:header>
            <div class="border-left custom-header-border float-left mt-1">
              <span class="mb-0 h3 ml-2">訂單明細</span>
            </div>
            <b-button class="ml-3 border float-right" @click="back">返回</b-button>
            <b-dropdown split text="匯出訂單明細" variant="light" class="border float-right" :split-href="deliverDownloadLink('xlsx')">
              <b-dropdown-item :href="deliverDownloadLink('xlsx')" target="_blank">xlsx</b-dropdown-item>
              <b-dropdown-item :href="deliverDownloadLink('ods')" target="_blank">ods</b-dropdown-item>
              <b-dropdown-item :href="deliverDownloadLink('json')" target="_blank">json</b-dropdown-item>
            </b-dropdown>
          </template>
          <h3 class="text-danger mb-5">
            <font-awesome-icon icon="exclamation-circle" class="mr-3"/>當前訂單狀態：{{DeliverStates}}
            <b-button variant="warning" class="float-right" size="sm" @click="onClickToRevoke">設為棄取訂單</b-button>
          </h3>
          <b-card-title class="text-info">• 訂單資訊</b-card-title>
          <b-card-body>
            <b-table :fields="MainFields" :items="MainData" bordered responsive head-variant="light" class="text-center"></b-table>
          </b-card-body>
          <b-card-title class="text-info">• 購買人資訊</b-card-title>
          <b-card-body>
            <b-table :fields="UserFields" :items="BuyerData" bordered responsive head-variant="light" class="text-center"></b-table>
          </b-card-body>
          <b-card-title class="text-info">• 取貨人資訊</b-card-title>
          <b-card-body>
            <b-table :fields="UserFields" :items="RecevierData" bordered responsive head-variant="light" class="text-center"></b-table>
          </b-card-body>
          <b-card-title class="text-info">• 商品明細</b-card-title>
          <b-card-body>
            <b-table :fields="ContentFields" :items="ContentData" bordered responsive head-variant="light" class="text-center" foot-clone>
              <template v-slot:foot()><div></div></template>
              <template v-slot:foot(sum)>
                <h5 class="text-danger mb-0">合計： {{Summary}}</h5>
              </template>
            </b-table>
          </b-card-body>
        </b-card>
        <template v-slot:overlay>
          <b-spinner v-if="processing" label="Spinning"></b-spinner>
          <div v-else>
            <font-awesome-icon class="text-success mr-2" icon="check"></font-awesome-icon>稍後返回列表
          </div>
        </template>
      </b-overlay>
    </b-col>
  </b-row>
</template>
<script>
import QueryString from 'querystring'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faExclamationCircle,
  faCheck
} from '@fortawesome/free-solid-svg-icons'
library.add(faExclamationCircle, faCheck)
import { Payments, DeliverStates } from '../../library/Var.js'
export default {
  name: 'deliver-view',
  data () {
    return {
      busy: false,
      processing: false,
      info: {}
    }
  },
  computed: {
    id () {
      return this.$route.params.id
    },
    MainFields () {
      return [
        { key: 'id', label: '訂單編號' },
        { key: 'acc', label: '購買人帳號' },
        { key: 'pm', label: '支付方式' },
        { key: 'sum', label: '訂單金額' },
      ]
    },
    MainData () {
      const { uqid = '', ref_user = {}, pay_type = '', total = 0 } = this.info
      const p = Payments.find(item => item.value === pay_type)
      return [{ id: uqid, acc: ref_user.username, pm: p ? p.name : 'unknown', sum: total}]
    },
    UserFields() {
      return [
        { key: 'name', label: '取貨人' },
        { key: 'school_num', label: '學號' },
        { key: 'tel', label: '聯絡電話' },
        { key: 'email', label: '聯絡信箱' },
      ]
    },
    BuyerData () {
      const { ref_user = {} } = this.info
      const { name, school_num, tel, email } = ref_user
      return [{ name, school_num, tel, email }]
    },
    RecevierData () {
      const { receiver_info = {} } = this.info
      const { name, school_num, tel, email } = receiver_info
      return [{ name, school_num, tel, email }]
    },
    ContentFields() {
      return [
        { key: 'id', label: '商品編號' },
        { key: 'name', label: '商品名稱' },
        { key: 'size', label: '商品規格' },
        { key: 'amount', label: '商品數量' },
        { key: 'sum', label: '金額' }
      ]
    },
    ContentData () {
      const { content = [] } = this.info
      return content.map(item => {
        const { ref_catalog = {}, ref_size = '', amount, total } = item
        const { serial_number, name, size: sizeArray } = ref_catalog
        const size = sizeArray.find(item => item._id === ref_size)
        return { id: serial_number, name, size: size.name, amount, sum: total}
      })
    },
    Summary () {
      const { total = 0 } = this.info
      return total
    },
    DeliverStates () {
      const { state = '' } = this.info
      return DeliverStates[state] || ''
    }
  },
  methods: {
    async fetch () {
      const { data } = await this.$api.getDelDetail(this.id)
      this.info = data
    },
    async onClickToRevoke () {
      // are u sure?
      const isOK = await this.$bvModal.msgBoxConfirm('您確定要把這筆訂單標記為棄取嗎?', {
        title: '再次確認',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: '確認',
        cancelTitle: '取消',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      if (isOK) {
        // call api
        this.processing = this.busy = true
        await this.$api.putDel(this.id, 'revoke')
        this.processing = false
        setTimeout(this.back, 3000)
      }
    },
    back () {
      this.$router.back()
    },
    deliverDownloadLink (format) {
      const obj = { format }
      const query = `?${QueryString.stringify(obj)}`
      return this.$api.urlDeliverDetail(this.id, query);
    }
  },
  mounted () {
    this.fetch()
  }
}
</script>
